import { z } from "zod";

export const GendersSchema = z.enum(["male", "female"]);
export type Genders = z.infer<typeof GendersSchema>;
